import {KRAKEN_POPSTAR_FEATURES} from "src/utils/commonKrakenUtility";

/**
 *  PopStar Feature gates enabled
 * */
export const getEnabledFeatureGates = (): Array<string> =>  KRAKEN_POPSTAR_FEATURES

 export const authenticatePopStarFeature = (featureName: string) => {
     return KRAKEN_POPSTAR_FEATURES.includes(featureName);
 }